export const mapDataForClient = user => ({
  firstName: user.attributes.given_name,
  lastName: user.attributes.family_name,
});
